import { render, staticRenderFns } from "./DadosCobranca.vue?vue&type=template&id=9bff922a"
import script from "./DadosCobranca.vue?vue&type=script&lang=js"
export * from "./DadosCobranca.vue?vue&type=script&lang=js"
import style0 from "./DadosCobranca.vue?vue&type=style&index=0&id=9bff922a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports